import React from 'react';

// One drawing per action, shared by navigation, lists and forms.
const paths = {
    info: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 11v6M12 7h.01',
    status: 'M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z',
    lock: 'M5 10h14v11H5zM8 10V7a4 4 0 0 1 8 0v3M12 14v3',
    target: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z',
    message: 'M21 3H3v14h5l4 4v-4h9V3ZM7 7h10M7 11h7',
    link: 'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-2 2M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l2-2',
    phone: 'M5 3h4l2 5-3 2a14 14 0 0 0 6 6l2-3 5 2v4a2 2 0 0 1-2 2C10 21 3 14 3 5a2 2 0 0 1 2-2Z',

    search: 'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
    map: 'M3 5l6-2 6 2 6-2v16l-6 2-6-2-6 2V5ZM9 3v16M15 5v16',
    eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
    list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
    tag: 'M3 3h8l10 10-8 8L3 11V3ZM7 7h.01',
    ruler: 'M3 17 17 3l4 4L7 21l-4-4ZM13 7l2 2M10 10l2 2M7 13l2 2',
    ban: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM5 5l14 14',

    maintenance: 'M14 6a5 5 0 0 0-6 6L3 17a3 3 0 0 0 4 4l5-5a5 5 0 0 0 6-6l-3 3-4-4 3-3Z',
    camera: 'M3 7h4l2-3h6l2 3h4v14H3zM16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
    back: 'M19 12H5M12 5l-7 7 7 7',
    clear: 'M4 14 14 4l7 7-10 10H8l-4-4v-3ZM9 9l7 7M11 21h10',

    dashboard: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
    building: 'M3 21h18M5 21V8l7-5 7 5v13M9 21v-7h6v7M9 9h.01M15 9h.01',
    equipment: 'M3 7l9-4 9 4v10l-9 4-9-4zM3 7l9 5 9-5M12 12v9',
    vehicle: 'M3 17V10l3-6h12l3 6v7H3zM3 10h18M6 17v3M18 17v3M6 13h2M16 13h2',
    chart: 'M4 3v18h17M8 17v-5M13 17V7M18 17V4',
    settings: 'M4 7h16M4 17h16M8 4v6M16 14v6',
    refresh: 'M20 7a8 8 0 0 0-14-2L3 8M3 3v5h5M4 17a8 8 0 0 0 14 2l3-3M21 21v-5h-5',
    clock: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 6v6l4 2',

    next: 'M9 5l7 7-7 7',
    up: 'M5 15l7-7 7 7',
    down: 'M5 9l7 7 7-7',
    grip: 'M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01',
    mail: 'M3 5h18v14H3zM3 6l9 7 9-7',
    send: 'M22 2 9 15M22 2l-7 20-6-7-7-6 20-7Z',
    test: 'M9 3h6M10 3v7L4 20h16l-6-10V3M7 15h10',
    bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M9 21h6',
    users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM17 3a4 4 0 0 1 0 8M22 21v-2a4 4 0 0 0-3-4',
    close: 'M6 6l12 12M18 6L6 18', plus: 'M12 5v14M5 12h14',
    edit: 'M15 5l4 4M4 20l4-1L20 7a2.8 2.8 0 0 0-4-4L4 15v5Z',
    trash: 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7',
    check: 'M5 12l4 4L19 6', copy: 'M9 9h12v12H9zM15 9V3H3v12h6',
    document: 'M14 2H5v20h14V7l-5-5ZM14 2v5h5M8 12h8M8 16h6',
    print: 'M6 9V3h12v6M6 17H3V9h18v8h-3M6 14h12v7H6zM17 11h1',
    download: 'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',
    upload: 'M12 16V4m-5 5 5-5 5 5M4 16v5h16v-5',
    save: 'M4 3h13l4 4v14H3V3h1ZM7 3v6h9V3M7 21v-8h10v8',
    calendar: 'M4 5h16v16H4zM8 3v4M16 3v4M4 10h16M8 14h2M14 14h2',
    briefcase: 'M3 7h18v14H3zM8 7V3h8v4M3 12l9 3 9-3M12 12v5',
    warning: 'M12 3 2 21h20L12 3ZM12 9v5M12 17v1',
    truck: 'M2 5h12v12H2zM14 10h4l4 4v3h-8M7 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM21 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z',
    finance: 'M3 9l9-6 9 6H3zM5 10v8M10 10v8M14 10v8M19 10v8M3 21h18',
    card: 'M3 5h18v14H3zM3 10h18M6 15h4',
    layers: 'M12 3l10 6-10 6L2 9zM2 13l10 6 10-6M2 17l10 6 10-6',
    shield: 'M12 3l8 3v6c0 5-8 9-8 9s-8-4-8-9V6zM8 12l3 3 5-6',
    forms: 'M8 5h12v16H8zM4 17V2h12M11 10h6M11 14h6',
    user: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M4 21v-2a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v2',
    pin: 'M8 3h8l-1 6 4 4H5l4-4zM12 13v8',
    menu: 'M4 6h16M4 12h16M4 18h16',
    appearance: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2',
    exit: 'M9 3H4v18h5M10 12h11M17 8l4 4-4 4',
    dl50: 'M8 4H5v17h14V4h-3M8 3h8v4H8zM8 12l2 2 5-5M8 18h8',
    andaime: 'M5 3v18M19 3v18M3 7h18M3 17h18M5 7l14 10M19 7L5 17',
    paperclip: 'M8 12l6-6a3 3 0 0 1 4 4l-8 8a5 5 0 0 1-7-7l8-8M6 14l8-8',
};
const aliases = { pdf: 'document', cross: 'close', original: 'paperclip', share: 'upload' };
export default function AppIcon({ name, size = 18, className = '' }) {
    const icon = aliases[name] || name;
    return <svg className={`app-icon ${className}`} data-icon={icon} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d={paths[icon] || paths.document} /></svg>;
}
